import React from 'react'
import { connect } from 'react-redux'
import './testSeaWayBill.less'
import { AppState } from '../../../reducers'
import './testSeaWayBill.less'
import SeaWayBill from '../../SeaWayBill'
import VehicleCard from '../../VehicleCard'
import Modal from 'react-modal'

const customStyles = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: '#FFF',
    height: '1200px',
  },
  content: {
    inset: '0',
    border: '0',
    margin: '0',
    padding: '0',
  },
}

interface OwnProps {
  onClose: () => void
  isShowSWB: boolean
}

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.originReservation,
  terminal: state.terminal.terminal,
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = StateProps & OwnProps

const Component: React.FC<Props> = ({ reservation, terminal, onClose, isShowSWB }: Props) => {
  if (!reservation || !terminal) {
    return null
  }
  return (
    <Modal ariaHideApp={false} isOpen={isShowSWB} style={customStyles} contentLabel="SWB">
      <div className="testSeaWayBill" onClick={onClose}>
        <div className="testSeaWayBill-inner">
          <div className="sea-way-template">
            <SeaWayBill reservation={reservation} terminal={terminal} />
            <VehicleCard reservation={reservation} />
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default connect(mapStateToProps)(Component)
